/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */


import React, { useState, useEffect, Fragment, useRef, useMemo } from "react";
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { keyframes } from "@mui/system";
import { Link } from "react-router-dom";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Stack,
  Divider,
  Paper,
  TextField,
  Box,
  Button,
  Badge,
  Typography,
  IconButton,
  FormGroup,
  FormControl,
  FormControlLabel,
  Menu,
  MenuItem,
  Switch,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Select,
} from "@mui/material";

import moment from "moment";
import { lightBlue, red } from "@mui/material/colors";
import { toast } from "react-toastify";
import ToPrintPageTestManagement from "./ToPrintPageTestManagement";
import LabRoomSelection from "./LabRoomSelection";
import ComponentToPrintWrapper from "./TestFormPrintFormat";
//import ReactToPrint from "react-to-print";
/*------------------ External Function -----------*/
import { convertToEngDate, convertToThaiDate } from "./functions/GlobalFunctions";

/*------------------ Redux -----------------------*/
import { useSelector, useDispatch } from 'react-redux';
import { fetchBookingInOnePeriod } from '../store/PgBookDateSlice';
import { fetchAllTestResvInfoInOnePeriod, fetchAllTestResvInfo } from '../store/TestReservationSlice';
import { fetchMemberInfoByUserType } from '../store/MemberInfoSlice';
import {
  setShowScoringCriteria,
  updateTestType,
  delAllTestFormByResvcode,
  createGrpTestForm,
  updateGrpTestForm,
  fetchAllTestForm,
  //fetchAllTestResultByDateAndTime,
  fetchTestFormByResvcode,
  //fetchTestResultByDateAndTime //---> added on 07-03-2025
} from '../store/TestMgmtSlice';
import { fetchSeatStatusInfoByDateAndTime } from '../store/SeatMgmtSlice';
import { fetchTestResultByResvCode } from '../store/TestResultSlice';

import UploadMediaDialogBox from "./UploadMediaDialog";

/*------------------------ Date Picker : BuddhistEra --------------*/
import OwnDatePickerExamMgmt from './OwnDatePickerExamMgmt';

/*----------------------- Style ------------------*/
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#FFF',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  fontFamily: 'THSarabunNew',
  color: theme.palette.text.secondary
}));

/*----------------- theme ------------------------*/
const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: 'THSarabunNew',
      fontSize: '14px'
    }
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
        },
      }
    },
  }
});

const muidatatabletheme = createTheme({
  components: {
    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          backgroundColor: lightBlue['50'],
        }
      }
    },
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
          fontSize: '12px'
        },
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
          fontSize: '12px'
        },
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
          fontSize: '12px'
        },
      }
    },
  }
});

/*------------------------ Blink Badge ------------------------*/
const blink = keyframes`
    from {
      opacity: 0; 
    }
    to { 
      opacity: 1;
    }
  `;

const BlinkBadge = styled(Badge)(({ theme }) => ({
  transform: 'translate(10px, -10px)',
  animation: `${blink} 1s infinite ease`
}));

/*---------------- DataGrid : Column -> Link Button : RenderCheckApprovalButton -----------*/
const RenderCheckApprovalButton = (props) => {
  const { data } = props;
  const [badgeVisible, setBadgeVisible] = useState(false);

  /*----------------------- Redux : useSelector -> fetchTestResvInfobyResvCode ------------------*/
  const res_byresvcode = useSelector((state) => state.testresvinfostate.testresvbyperiod);

  let res_tmp = res_byresvcode.data?.filter((el) => el.testresvcode === data.resvcode);
  useEffect(() => {
    if (res_tmp[0]?.testappvcode === null) {
      setBadgeVisible(true);
    } else {
      setBadgeVisible(false);
    }
  }, [res_tmp[0]?.testappvcode, res_byresvcode, data]);

  return (
    <Link
      to={"/PageCheckApproval"}
      state={{
        'data': data
      }}
      style={{ textDecoration: "none" }}>
      <Box>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{
            fontFamily: 'THSarabunNew',
            marginLeft: 16
          }}
        >
          อนุมัติ
        </Button>
        {
          badgeVisible &&
          <BlinkBadge
            badgeContent={'NEW'}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            //color='warning'
            sx={{
              '& .MuiBadge-badge': {
                fontFamily: 'THSarabunNew',
                fontWeight: 'bold',
                fontSize: 10,
                color: 'whitesmoke',
                backgroundColor: '#FBC02D',
                borderRadius: '5%'
              }
            }}
          />
        }
      </Box>
    </Link>
  );
}//End of RenderCheckApprovalButton

/*******************************************************************************/
/************************ ContentPageTestManagement ****************************/
/*******************************************************************************/
function ContentPageTestManagement() {
  const t_period = ['0900 - 1015', '1030 - 1145', '1330 - 1445'];
  const t_format = ['09:00:00', '10:30:00', '13:30:00'];

  const labRoomSelectionRef = useRef();
  const [rows, setRows] = useState([]);
  const [tmprows, setTmpRows] = useState([]);
  const [scoringshowed, setShowScoring] = useState([]);
  const [openLabRoomdlg, setOpenLabRoomDlg] = useState(false);

  const setLabRoomDlgState = (state) => {
    //console.log('223 labroomdlgstate ---> state : ', state)
    setOpenLabRoomDlg(state);
  };

  /*----------------- Event : Sort Menu Handle -------------*/
  const btnSortRef = useRef(null);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const [sortDateClick, setSortDateClick] = useState(false);
  //const [sortResvCodeClick, setSortResvCodeClick] = useState(false);
  const [sortUnitClick, setSortUnitClick] = useState(false);

  /*--------------- Event : Select Labroom Handle ----------*/
  const btnSelLabroomRef = useRef(null);
  const [selLabroomMenuOpen, setSelLabroomMenuOpen] = useState(false);

  /*------------------------ Redux : MemberInfo ----------------*/
  const meminfodispatch = useDispatch();
  useMemo(() => {
    meminfodispatch(fetchMemberInfoByUserType('USR03'));
  }, [meminfodispatch]);

  const meminfobyusrtype = useSelector((state) => state.memberinfostate.meminfobyusrtype);
  const [invigilatorList, setInvigilatorList] = useState([]);
  useMemo(() => {
    if (meminfobyusrtype?.length !== 0) {
      let invigilatorlist = meminfobyusrtype?.map(e => ({
        'pers_id': e['tbmember.pers_id'],
        'name': e['tbmember.tbmemberinfos.mem_rank'] +
          e['tbmember.tbmemberinfos.mem_fname'] + ' ' +
          e['tbmember.tbmemberinfos.mem_lname']
      }));

      setInvigilatorList(invigilatorlist);
    }
  }, [meminfobyusrtype]);

  /*---------------------- Dispatch ----------------------------*/
  const [childrows, setChildRows] = useState([]);
  const [showscoringchanged, setShowScoringChanged] = useState(false);
  const [testtypechanged, setTestTypeChanged] = useState(false);
  const testtypeDispatch = useDispatch();
  const scoringshowDispatch = useDispatch();
  const alltestresvdispatch = useDispatch();
  useEffect(() => {
    alltestresvdispatch(fetchAllTestResvInfo());
  },
    [
      alltestresvdispatch,
      openLabRoomdlg,
      testtypechanged,
      showscoringchanged,
      sortDateClick,
      //sortResvCodeClick,
      sortUnitClick,
    ]);
  const alltestresvlist = useSelector((state) => state.testresvinfostate.alltestresvarr);

  //console.log('281 : ContentPageTestManagement ---->', alltestresvlist, ' : ', openLabRoomdlg)

  useEffect(() => {
    let childrows_tmp = [];
    let alllist_tmp = [];
    alltestresvlist?.data?.map(e => {
      alllist_tmp.push({
        'resvcode': e['tbtestreservation.testresvcode'],
        'testappcode': e['tbtestreservation.testappvcode'],
        'reqdate': e['tbtestreservation.testreqdate'],
        'reqtime': e['tbtestreservation.testreqtime'],
        'scoringshowed': Boolean(e['showscoringcriteria']),
        'invigilatorid': e['invigilator'],
        'testtype': e['testtype'],
        'testrequnit': e['tbtestreservation.testrequnit'],
        'testmission': e['tbtestreservation.tbtestscoringcriterium.mission']
      });
      childrows_tmp.push({
        'resvcode': e['tbtestreservation.testresvcode'],
        'labroom': e['tblabroom.labroomcode'],
        'invigilatorid': e['invigilator'],
      });
    });

    let child_rows = childrows_tmp.reduce((a, b) => {
      if (!a.find(el => el.resvcode === b.resvcode && el.labroom === b.labroom)) {
        a.push(b);
      };
      return a;
    }, []);
    setChildRows(child_rows);

    let res = alllist_tmp.reduce((a, b) => {
      if (!a.find((item) => item.resvcode === b.resvcode)) {
        a.push(b);
      }
      return a;
    }, []);

    setShowScoring(res);
  }, [alltestresvlist, rows.length]);

  /*-------------------- Form Select -------------------------------*/
  const alltestresultlbDispatch = useDispatch();
  const [seltestform, setSelTestForm] = useState([]);
  const [alltestform, setAllTestForm] = useState([]);

  /*------------------ added on 25-02-2024 --------------------------*/
  const testformlist = useSelector((state) => state.testmgmtstate.questionform);
  const alltestfrmDispatch = useDispatch();
  useMemo(() => {
    alltestfrmDispatch(fetchAllTestForm());
  }, [alltestfrmDispatch]);

  useMemo(() => {
    let tmp = ['กรุณาเลือกฟอร์ม', ...Object.values({ ...testformlist }), 'คละฟอร์ม'];
    setAllTestForm(tmp);
  }, [testformlist, setAllTestForm]);

  /*----------------- Form Dispatch --------------------------*/
  const delTestFormByResvcodePersidDispatch = useDispatch();
  const updateGrpTestFrmDispatch = useDispatch();
  const createGrpTestFormDispatch = useDispatch();

  /*------------------------ MuiDataTables : Columns ----------------*/
  const [seltypearr, setSelTypeArr] = useState([]);
  const initTypeArrRef = useRef([]);

  /*---------------------- added on 17-01-2025 ----------------------*/
  const [prevdatetime, setPrevDateTime] = useState(null);
  const [newresvdate, setNewResvDate] = useState(null);
  const [newresvtime, setNewResvTime] = useState([]);

  const seatStatusInfoDispatch = useDispatch();
  const totalExamineeDispatch = useDispatch();
  useMemo(() => {
    if (prevdatetime) {
      let tmpdate = convertToThaiDate(
        (prevdatetime['date'] !== newresvdate && newresvdate) ? newresvdate : prevdatetime['date']
      );
      let tmptime = (
        (prevdatetime['time'] !== newresvtime[0] && newresvtime[0]) ? newresvtime[0] : prevdatetime['time']
      ).split('-')[0].replace(/(\d{2})(\d{2})/, "$1:$2");

      seatStatusInfoDispatch(fetchSeatStatusInfoByDateAndTime({
        'date': tmpdate,
        'time': tmptime
      })).then(res => {
        let totalseat = Object.values(res.payload.data.totalseat).reduce((a, b) => a + b, 0);
        let seatcount = Object.values(res.payload.data.seatcount).reduce((a, b) => a + b, 0);
        let remainseat = totalseat - seatcount;

        let mbr_resvcode = alltestresvlist?.data?.filter(
          elm => elm['tbtestreservation.testresvcode'] === prevdatetime['resvcode']
        );

        if (remainseat >= mbr_resvcode.length) {
          console.log('seat remain');


        } else {
          console.log('seat not remain');


        }

      });
    }
  }, [newresvdate, newresvtime]);

  /*-------------------------- Column defined -----------------------*/
  const columns = [
    {
      name: "ลำดับ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '50px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '50px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: "รหัสการจอง",
      options: {
        filter: true,
        sort: false,
        display: false,//---------> added on 07-01-2025
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '150px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '150px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    //---------> added on 07-01-2025
    {
      name: "หน่วยงาน",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '50px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '50px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: "รายการทดสอบ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: "วันที่จอง",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <OwnDatePickerExamMgmt
              disabled={!tableMeta.rowData[7].includes('APRV') ?? false}
              currdate={tableMeta.rowData[4]}
              setNewResvDate={setNewResvDate}
            />
          );
        }
      }
    },
    {
      name: "เวลาที่จอง",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '120px',
            textAlign: 'center',
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '120px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Select
              sx={{
                minWidth: 150,
                boxShadow: 'none',
                '.MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
              }}
              value={
                !newresvtime[tableMeta.rowData[0] - 1] ?
                  t_period[tableMeta.rowData[5]] : newresvtime[tableMeta.rowData[0] - 1]
              }
              disabled={!tableMeta.rowData[7].includes('APRV') ?? false}
              onChange={evt => {
                let newarr = [...newresvtime];
                newarr[tableMeta.rowData[0] - 1] = evt.target.value;
                setNewResvTime(newarr);
              }}
            >
              {
                t_period.map((item, i) =>
                  <MenuItem key={i} value={item}>{item}</MenuItem>
                )
              }
            </Select>
          )
        }
      },
    },
    {
      name: "สถานที่สอบ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button id={value}
              variant="contained"
              disabled={!tableMeta.rowData[7].includes('APRV') ?? false}
              onClick={() => {
                if (tableMeta.rowData[7] !== 'รออนุมัติการจอง') {
                  labRoomSelectionRef.current.handleClickOpenDlg(
                    tableMeta.rowData[1],
                    convertToEngDate(tableMeta.rowData[4]),
                    t_format[tableMeta.rowData[5]]
                  )
                } else {
                  //-----> add some codes
                }
              }}
            >
              เลือกสถานที่สอบ
            </Button>
          )
        }
      }
    },
    {
      name: "รหัสการสอบ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '120px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '120px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
      },
    },
    {
      name: "แบบ",
      options: {
        filter: true,
        sort: false,
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            //width: '200px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          let _list = alltestresvlist?.data?.filter(
            e => e['tbtestreservation.testresvcode'] === tableMeta.rowData[1]
          );

          let selectedtype = 0;
          if (_list?.length > 1) {
            let samechk = _list.every(
              e => e.testtype === _list[0]['testtype'] ? true : false
            );
            selectedtype = samechk ? scoringshowed?.filter(
              e => e.resvcode === tableMeta.rowData[1]
            )[0]?.testtype : 3;
          } else {
            selectedtype = scoringshowed?.filter(
              e => e.resvcode === tableMeta.rowData[1]
            )[0]?.testtype;
          }
          /*----------------------------------------------------------------------*/
          return (
            <Select
              sx={{
                boxShadow: 'none',
                '.MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
                fontSize: '12px',
                fontFamily: 'THSarabunNew',
                width: '100%',
              }}
              value={
                !tableMeta.rowData[7].includes('DISAP') ?
                  seltypearr[tableMeta.rowData[0] - 1] || (selectedtype ?? 0) :
                  0
              }

              disabled={!tableMeta.rowData[7].includes('APRV') ?? false}
              onChange={(evt) => {
                let newarr = [...seltypearr];
                newarr[tableMeta.rowData[0] - 1] = evt.target.value;
                setSelTypeArr(newarr);
                /*------------------- update database --------------*/
                if (evt.target.value !== 3) {
                  testtypeDispatch(
                    updateTestType({
                      'rsrvcode': tableMeta.rowData[1],
                      'testtype': evt.target.value
                    })
                  ).then(res => {
                    if (res.payload.data.completed) {
                      setTestTypeChanged(!testtypechanged);
                      toast.success('อัพเดทรูปแบบการสอบเรียบร้อยแล้ว', { position: 'top-center' });
                    } else {
                      toast.error('เกิดข้อผิดพลาด ไม่สามารถอัพเดทรูปแบบการสอบได้', { position: 'top-center' });
                    }
                  });
                } else {
                  toast.warning(
                    'ท่านไม่สามารถเลือกคละรูปแบบการสอบได้ กรุณาเลือกรูปแบบการสอบที่ต้องการ',
                    { position: 'top-center' }
                  );
                }//end if
              }}
            >
              {
                ['เลือกรูปแบบการสอบ', 'Random Test', 'Adaptive Test', 'คละรูปแบบการสอบ'].map((el, i) => {
                  return (
                    <MenuItem
                      key={i}
                      value={i}
                      style={{
                        fontSize: '12px',
                        fontFamily: 'THSarabunNew',
                      }}
                    >
                      {el}
                    </MenuItem>
                  )
                })
              }
            </Select>
          )
        }
      }
    },
    {
      name: "ฟอร์ม",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            //width: '150px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            //width: '150px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          //console.log('770 : index ', tableMeta.rowIndex, ' : ', tableMeta.rowData, ' : ', seltestform)
          return (
            <FormControl fullWidth>
              <Select
                sx={{
                  boxShadow: 'none',
                  '.MuiOutlinedInput-notchedOutline': { border: 0 },
                  '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
                  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
                  fontSize: '12px'
                }}
                //value={seltestform[tableMeta.rowIndex] ?? 0}
                value={seltestform[tableMeta.rowIndex] ?? alltestform.indexOf(tableMeta.rowData[8])}
                disabled={!tableMeta.rowData[7].includes('APRV') ?? false}
                onChange={(evt) => {
                  /*--------------- gen form --------------------------*/
                  let testfrm = {};
                  createGrpTestFormDispatch(createGrpTestForm(testformlist[parseInt(evt.target.value) - 1]))
                    .then(grptestfrm => {
                      testfrm = grptestfrm.payload;
                    }); //end of then ---> createGrpTestFormDispatch

                  alltestresultlbDispatch(
                    fetchTestResultByResvCode(tableMeta.rowData[1])
                  )
                    .then(async res_1 => {
                      if (res_1.payload.data.length !== 0) {
                        let success = await Promise.all(res_1.payload.data.map((d, index) => {
                          delTestFormByResvcodePersidDispatch(delAllTestFormByResvcode({
                            'allfrmresvcode': d['testresultcode']
                          }))
                            .then(res_2 => {
                              if (res_2.payload.del_success) {
                                let newarr = [...seltestform];
                                newarr[tableMeta.rowIndex] = evt.target.value;
                                setSelTestForm(newarr);

                                updateGrpTestFrmDispatch(updateGrpTestForm({
                                  'resvcode': d['testresvcode'],
                                  'persid': d['testresultcode'].split('-')[1],
                                  'form': (((index + 1) % 2) !== 0) ? testfrm.form_A : testfrm.form_B,
                                }));
                              }
                            }); //end then 
                        }));//end -> Promise.all

                        if (success.length === res_1.payload.data.length) {
                          toast.success('สร้างแบบทดสอบรายบุคคลเรียบร้อยแล้ว', { position: 'top-center' });
                        } else {
                          toast.error('เกิดข้อผิดพลาด ไม่สามารถสร้างแบบทดสอบรายบุคคลได้', { position: 'top-center' });
                        }
                      }//end if after then
                    });
                }}//end of onChange
              >
                {
                  ['กรุณาเลือกฟอร์ม', ...Object.values({ ...testformlist }), 'คละฟอร์ม'].map((frm, i) => {
                    return (
                      <MenuItem
                        sx={{
                          fontFamily: 'THSarabunNew', fontSize: '12px'
                        }}
                        value={i}
                        key={i}
                      >
                        {frm}
                      </MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl >
          )//--> end of return 
        }
      },
    },
    {
      name: "ไฟล์ข้อสอบ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '150px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '150px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <ComponentToPrintWrapper
              key={tableMeta.rowIndex}
              item={tableMeta.rowData}
              selfrm={seltestform[tableMeta.rowIndex] ?? alltestform.indexOf(tableMeta.rowData[8])}
            />
          )
        },
      },
    },
    {
      name: "ดูรายชื่อ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '150px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '150px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <strong>
              <Link to="/PageExamManagement"
                state={{
                  'rowdata': alltestresvlist?.data?.filter(
                    elm => elm['tbtestreservation.testresvcode'] === tableMeta.rowData[1]
                  )
                }}
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ marginLeft: 16 }}
                >
                  เข้าดูรายชื่อ
                </Button>
              </Link>
            </strong>
          )
        }
      },
    },
    {
      name: "แสดงเกณฑ์การผ่าน",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <FormGroup>
              <FormControlLabel
                style={{ justifyContent: 'center' }}
                control={
                  <Switch
                    id={`${tableMeta.rowData[0] - 1}`}
                    checked={
                      Boolean(scoringshowed?.filter(elem => elem.resvcode === tableMeta.rowData[1])[0]?.scoringshowed)
                    }
                    disabled={!tableMeta.rowData[7].includes('APRV') ?? false}
                    onChange={(e, c) => {
                      let newarr = scoringshowed?.map(elem => (
                        elem.resvcode === tableMeta.rowData[1] ?
                          { ...elem, scoringshowed: c } :
                          elem
                      ));
                      setShowScoring(newarr);
                      scoringshowDispatch(setShowScoringCriteria({
                        rsrvcode: tableMeta.rowData[1],
                        scoringshowed: c
                      })).then(res => {
                        if (res.payload.data.completed) {
                          setShowScoringChanged(!showscoringchanged);
                          toast.success('อัพเดทการแสดงเกณฑ์คะแนนเรียบร้อยแล้ว', { position: 'top-center' });
                        } else {
                          toast.error('เกิดข้อผิดพลาด ไม่สามารถอัพเดทการแสดงเกณฑ์คะแนนได้', { position: 'top-center' });
                        }
                      });
                    }}
                  />
                } />
            </FormGroup>
          )
        }
      },
    },
    {
      name: "อนุมัติการจองวันทดสอบ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            justifyContent: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '200px',
            justifyContent: 'center',
            fontWeight: 'bold'
          }
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <RenderCheckApprovalButton
              data={{
                'resvcode': tableMeta.rowData[1],
                'resvdate': tableMeta.rowData[4],
                'resvtime': t_format[tableMeta.rowData[5]].substring(0, 5)
              }}
            />
          )
        }
      },
    }
  ];

  /*------------------------ MuiDataTables --> options -------------------*/
  const options = {
    filter: false,
    selectableRows: 'none',
    //filterType: 'dropdown',
    //fixedHeader: false,
    elevation: 0,
    print: false,
    search: false,
    viewColumns: false,
    download: false,
    responsive: 'simple',
    rowsPerPage: 10,
    expandableRows: true,
    textLabels: {
      body: {
        noMatch: "ไม่พบข้อมูลที่ต้องการ",
      },
      pagination: {
        next: "หน้าถัดไป",
        previous: "หน้าก่อนหน้า",
        rowsPerPage: "จำนวนแถวต่อหน้า:",
        displayRows: "ของ",
      },
    },
    renderExpandableRow: (rowData, rowMeta) => {
      let tmpchildrows = childrows?.filter(e => e.resvcode === rowData[1]);
      if (tmpchildrows[0].labroom !== 'lab0') {
        return (
          <tr>
            <td colSpan={5}>
              <Table>
                <TableHead>
                  <TableRow>
                    {
                      ['ห้องสอบ', 'ชื่อผู้คุมสอบ'].map((elm, i) => {
                        return (
                          <TableCell
                            style={{
                              fontSize: '12px',
                              fontFamily: 'THSarabunNew',
                              fontWeight: 'bold'
                            }}
                            align="center"
                            key={i}
                          >
                            {elm}
                          </TableCell>
                        )
                      })
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    tmpchildrows.filter(e => e.labroom !== 'lab0').map((chrow, ind) => (
                      <TableRow key={ind}>
                        <TableCell
                          style={{
                            fontSize: '12px',
                            fontFamily: 'THSarabunNew',
                          }}
                          align='center'
                          key={0}
                        >
                          {chrow.labroom.toUpperCase()}
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: '12px',
                            fontFamily: 'THSarabunNew',
                          }}
                          align='center'
                          key={1}
                        >
                          {
                            invigilatorList?.filter(e => e.pers_id === chrow.invigilatorid)[0]?.name
                          }
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </td>
          </tr>
        );// end return
      } else {//if else
        return (
          <tr>
            <td colSpan={6}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell
                      style={{
                        fontSize: '12px',
                        fontFamily: 'THSarabunNew',
                        fontWeight: 'bold',
                        color: red['500']
                      }}
                    >
                      {
                        !rowData[7].includes('APRV') ?
                          'ท่านไม่สามารถกำหนดสถานที่สอบได้ กรุณาตรวจสอบสถานะการจอง !!!'
                          : `ท่านยังไม่ได้กำหนดสถานที่สอบให้กับรหัสการจอง ${rowData[1]} กรุณาเลือกสถานที่สอบ !!!`
                      }
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </td>
          </tr>
        )
      }//end else
    },
    onRowClick: (rowData, rowMeta) => {
      /*let curr_date = moment(new Date());
      let resv_date = convertToEngDate(rowData[4].props.currdate) + ' ' + rowData[5].props.value.split('-')[0].replace(/(\d{2})(\d{2})/, "$1:$2");

      console.log('1118 -> ', curr_date, ' : ', new Date(resv_date))
      console.log('1119 -> ', typeof (curr_date), ' : ', typeof (resv_date), ' : ', moment(curr_date).diff(resv_date, 'days'))
      if (moment(curr_date).diff(resv_date, 'days') >= 3) {*/
      setPrevDateTime({
        'resvcode': rowData[1],
        'date': convertToEngDate(rowData[4].props.currdate),
        'time': rowData[5].props.value
      });
      //}
    }
  }


  /*-------------------------------------------------------------*/
  const months = [
    "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
    "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
  ];

  const [curr_month, setCurrMonth] = useState(new Date().getMonth());
  const [curr_year, setCurrYear] = useState(new Date().getFullYear() + 543);
  const [movedirection, setMoveDirection] = useState(0);

  /*---------------------- Function : Month Selection -----------------------*/
  const handlePrevMonth = () => {
    setCurrMonth(curr_month - 1);
    setMoveDirection(-1);
  }

  const handleNextMonth = () => {
    setCurrMonth(curr_month + 1);
    setMoveDirection(1);
  }

  let m = ((curr_month % months.length) + months.length) % months.length;
  useEffect(() => {
    switch (movedirection) {
      case 1:
        if (m === 0) {
          setCurrYear(curr_year + 1);
        }
        break;
      case -1:
        if (m === 11) {
          setCurrYear(curr_year - 1);
        }
        break;
      default: break;
    }
  }, [m]);

  /*---------------------- Redux : Test Reservation -> booking period --------*/
  let fd_month = moment(new Date((curr_year - 543), m, 1)).format('YYYY-MM-DD');
  let ld_month = moment(new Date((curr_year - 543), m + 1, 0)).format('YYYY-MM-DD');

  /*--------- Redux : fetching test reservation by date ----------------*/
  const testresvbydatedispatch = useDispatch();
  useEffect(() => {
    testresvbydatedispatch(fetchAllTestResvInfoInOnePeriod({ 's_date': fd_month, 'e_date': ld_month }));
  }, [testresvbydatedispatch, curr_year, m]);
  const res_byresvcode = useSelector((state) => state.testresvinfostate.testresvbyperiod);

  /*--------------------- Redux to help LabRoomSelection to get reqNumSeat -----*/
  const bookdatedispatch = useDispatch();
  useMemo(() => {
    bookdatedispatch(fetchBookingInOnePeriod({ 's_date': fd_month, 'e_date': ld_month }));
  }, [bookdatedispatch, curr_year, m]);

  /*------------------------- Rows Data --------------------*/
  const timeIndexFunc = (time) => {
    let t = time.slice(0, -3).split(":").join("");
    return (t_period.findIndex(elm => elm.includes(t)));
  }

  const testformByResvcodeDispatch = useDispatch();

  useEffect(() => {
    let tmp = [];
    res_byresvcode?.data?.map((el, i) => {
      testformByResvcodeDispatch(fetchTestFormByResvcode({ 'resvcode': el.testresvcode }))
        .then((res) => res.payload.form)
        .then(frm => {
          tmp.push([
            i + 1,
            el.testresvcode,
            el.testrequnit,
            el['tbtestscoringcriterium.mission'],
            convertToThaiDate(el.testreqdate),
            timeIndexFunc(el.testreqtime),
            i + 1, //-->สถานที่สอบ
            el.testappvcode !== null ? el.testappvcode : 'รออนุมัติการจอง',
            frm
          ]);
        });
    });
    setRows(tmp);
    setTmpRows(tmp)
  }, [res_byresvcode, setRows, setTmpRows]);

  useEffect(() => {
    const sorted = [...rows].sort((a, b) => a[0] - b[0]);
    setRows(sorted);
    setTmpRows(sorted);
  }, [setRows, setTmpRows])
  /*------------------ Event : TextField Changed -----------------*/
  const handleTextChange = (evt) => {
    let data = tmprows.map(row => {
      if (row.filter(el => String(el).includes(evt.target.value)).length > 0)
        return row;
    }).filter(e => e).map((e, i) => {
      e[0] = i + 1;
      return e;
    });

    if (data.length !== 0) {
      setRows(data);
    } else if (evt.target.value === '') {
      setRows(tmprows);
    } else {
      setRows([]);
    }
  }

  /*---------------------- sortByDateFunc -----------------------*/
  const sortByDateFunc = () => {
    if (sortDateClick) {
      tmprows.sort((a, b) => {
        return (
          new Date(convertToEngDate(a[4])) - new Date(convertToEngDate(b[4])) || a[5] - b[5]
        );
      });
    } else {
      tmprows.sort((a, b) => {
        return (
          new Date(convertToEngDate(b[4])) - new Date(convertToEngDate(a[4])) || a[5] - b[5]
        );
      });
    }

    let _tmp = [...tmprows];
    _tmp.map((e, i) => { e[0] = i + 1 });

    setRows(_tmp);
  }

  /*---------------------- sortByUnitFunc --------------------*/
  const sortByUnitFunc = () => {
    if (sortUnitClick) {
      tmprows.sort((a, b) => {
        return (
          (a[2] === b[2]) ? 0 : (a[2] < b[2]) ? -1 : 1
        );
      });
    } else {
      tmprows.sort((a, b) => {
        return (
          (a[2] === b[2]) ? 0 : (a[2] > b[2]) ? -1 : 1
        );
      });
    }

    let _tmp = [...tmprows];
    _tmp.map((e, i) => { e[0] = i + 1 });

    setRows(_tmp);
  }//End of sortByUnitFunc

  /*------------------ Handle Sort Menu Click && Labroom Selection ----------------*/
  const handleSortMenuOnClick = (evt) => () => {
    switch (evt) {
      case 0: //sort by date
        sortByDateFunc();
        setSortDateClick(!sortDateClick);
        break;
      case 1:
        sortByUnitFunc(); //sort by unit
        setSortUnitClick(!sortUnitClick);
        break;
        default: break;
    }
    setSortMenuOpen(false);
  }

  const handleSelLabroomMenuOnClick = (evt) => () => {
    if (selLabroomMenuOpen) {
      setSelLabroomMenuOpen(false);
    }
  }

  /*----------------- Upload Media added 10-03-2024 -----------------*/
  const [openMediaDlg, setOpenMediaDlg] = useState(false);

  /*****************************************************/
  /***************** return ****************************/
  /*****************************************************/
  return (
    <ThemeProvider theme={theme}>
      <Stack
        divider={<Divider flexItem />}
        spacing={1}
      >
        {/*-------------- Title -----------------*/}
        <Item
          elevation={0}
          sx={{
            fontSize: '24px',
            fontWeight: 'bold',
          }}>
          การจัดการทดสอบ
        </Item>
        {/*-------------- Month & Year -----------------*/}
        <Item elevation={0}>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <IconButton onClick={handlePrevMonth}>
                <ChevronLeftIcon />
              </IconButton>
              <Typography variant="prev_month" gutterBottom>
                {months[m === 0 ? 11 : m - 1]} {m === 0 ? curr_year - 1 : curr_year}
              </Typography>
            </Box>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '18px',
              fontWeight: 'bold',
            }}>
              {months[m]} {curr_year}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Typography variant="next_month" gutterBottom>
                {months[(m + 1) % 12]} {m === 11 ? curr_year + 1 : curr_year}
              </Typography>
              <IconButton onClick={handleNextMonth}>
                <NavigateNextIcon />
              </IconButton>
            </Box>
          </Box>
        </Item>
        {/*-------------- TextField & Button on Page -----------------*/}
        <Item elevation={0}>
          <Stack direction={'row'} sx={{ alignItems: 'center', justifyContent: 'center' }}>
            {/*-------------- Page Print -----------------*/}
            <Item elevation={0}>
              <ToPrintPageTestManagement
                toprint={{
                  'tbrows': rows,
                  'subtbrows': childrows,
                  'testtype': seltypearr.length === 0 ? initTypeArrRef : seltypearr,
                  'invigilator': invigilatorList
                }}
              />
            </Item>
            {/*-------------- Search -----------------*/}
            <Item elevation={0}>
              <TextField
                variant="outlined"
                sx={{ width: 500 }}
                InputProps={{
                  style: {
                    height: '38px'
                  }
                }}
                onChange={handleTextChange}
              />
            </Item>
            {/*-------------- Sort -----------------*/}
            <Item elevation={0}>
              <Fragment>
                <Button
                  ref={btnSortRef}
                  aria-controls={'basic-menu'}
                  aria-haspopup='true'
                  aria-expanded={sortMenuOpen ? 'true' : undefined}
                  variant={'contained'}
                  endIcon={<ExpandMoreIcon />}
                  onClick={() => {
                    setSortMenuOpen(!sortMenuOpen);
                  }}
                >
                  จัดเรียง
                </Button>
                <Menu
                  anchorEl={btnSortRef.current}
                  open={sortMenuOpen}
                  onClose={() => btnSortRef.current = null}
                >
                  <MenuItem onClick={handleSortMenuOnClick(0)}>ตามวันที่จอง</MenuItem>
                  <MenuItem onClick={handleSortMenuOnClick(1)}>ตามหน่วยงาน</MenuItem>
                </Menu>
              </Fragment>
            </Item>
            <Item elevation={0}>
              <Fragment>
                <Button
                  ref={btnSelLabroomRef}
                  aria-controls={'basic-menu'}
                  aria-haspopup='true'
                  aria-expanded={selLabroomMenuOpen ? 'true' : undefined}
                  variant='contained'
                  endIcon={<ExpandMoreIcon />}
                  onClick={() => {
                    setSelLabroomMenuOpen(!selLabroomMenuOpen);
                  }}
                >
                  การจัดการห้องสอบ
                </Button>
                <Menu
                  anchorEl={btnSelLabroomRef.current}
                  open={selLabroomMenuOpen}
                  onClose={handleSelLabroomMenuOnClick}
                >
                  <MenuItem
                    component={Link}
                    to="/PageLabroomManagement"
                    state={{ 'labroom': 'lab1' }}
                    onClick={handleSelLabroomMenuOnClick(1)}
                  >LAB1</MenuItem>
                  <MenuItem
                    component={Link}
                    to="/PageLabroomManagement"
                    state={{ 'labroom': 'lab2' }}
                    onClick={handleSelLabroomMenuOnClick(2)}
                  >LAB2</MenuItem>
                  <MenuItem
                    component={Link}
                    to="/PageLabroomManagement"
                    state={{ 'labroom': 'lab3' }}
                    onClick={handleSelLabroomMenuOnClick(3)}
                  >LAB3</MenuItem>
                  <MenuItem
                    component={Link}
                    to="/PageLabroomManagement"
                    state={{ 'labroom': 'lab6' }}
                    onClick={handleSelLabroomMenuOnClick(6)}
                  >LAB6</MenuItem>
                </Menu>
              </Fragment>
            </Item>
            <Item elevation={0}>
              <Button
                variant="contained"
                onClick={() => {
                  setOpenMediaDlg(true);
                }}
              >
                อัพโหลดวีดิโอแนะนำ
              </Button>
            </Item>
          </Stack>
        </Item>

        {/*-------------- Table -----------------*/}
        <Item elevation={0}>
          <ThemeProvider theme={muidatatabletheme}>
            <MUIDataTable
              data={rows}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Item>
        <LabRoomSelection ref={labRoomSelectionRef} setLabRoomDlgState={setLabRoomDlgState} />
        {openMediaDlg && <UploadMediaDialogBox action={{ openMediaDlg, setOpenMediaDlg }} />}
      </Stack>
    </ThemeProvider>
  );
}

export default ContentPageTestManagement;